export { default } from './Thanks'



// WEBPACK FOOTER //
// ./src/components/Thanks/index.js